import React, { FC, ReactNode, useState, useEffect, useRef } from 'react';
import { Collapse, Row, Col } from 'reactstrap';
import { Utilities } from '@utils';
import { FaExclamation, FaCheck } from 'react-icons/fa';
import styles from './aea-step.module.scss';

export interface AEAStepProps{
    index?: number;
    children: ReactNode;
    title: string;
    description?: string;
    valid?: boolean;
    active?:boolean;
    onChangeStep?: Function;
    id?: string;
    onValidationFuncion?(container: any): boolean;
}

const AEAStep: FC<AEAStepProps> = (props: AEAStepProps) => {
    let _isValid = null
    const container = useRef();
    
    if(!Utilities.isNullObject(props.onValidationFuncion)){
      _isValid = props.onValidationFuncion(container.current);
    }
    const stateIndex = Utilities.isNullObject(_isValid) ? props.index : _isValid ? <FaCheck />: <FaExclamation />;
    return (
        <div className={styles.Step} data-open={props.active} data-error={Utilities.isNullObject(_isValid) ? null : !_isValid} ref={container}>
            <Row 
                className={styles.StepHeader}>
                <Col 
                    className={styles.StepNumber}
                    onClick={() => props.onChangeStep(props.id)}>
                    {stateIndex}  
                </Col>
                <Col className={styles.StepTitle}>
                    {props.title}
                </Col>
                <Col>
                    {props.description}
                </Col>
            </Row>
            <Collapse isOpen={props.active} className={styles.StepContent}>
                {props.children}
            </Collapse>
        </div>
    )
}

export default AEAStep;
